module.exports = __webpack_public_path__ + "static/media/seriousEr.2555253b.mp3";